import React from 'react';
// import { useMountEffect } from 'primereact/hooks';
// import { Messages } from 'primereact/messages';
import { ReactComponent as ErrorUpload } from '../assets/images/upload_error.svg';
import "../styles/components/alert.scss"

const  AlertComponent = ( props ) => {
    const errors = props.errors;
    // const { errors , alert, success } = props;
    // const msgs = useRef(null);

    // useMountEffect(() => {
    //     msgs.current.show(
    //         { sticky: true, severity: 'error', detail: errors, closable: false }
    //     );
    // });

    console.log("errors", errors)

    return (
        <div className="error-alert">
            {/* <div className="unique-errors col-sm-12">
                <Messages ref={msgs} />
            </div> */}
            <span className="error-icon"><ErrorUpload/></span>
            <span className='error-list'>
                {errors.map((str)=>(
                    <div>{str}</div>
            ))}
            </span>
        </div>
    )

}

export default AlertComponent;